<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-7 bg-gradient">
    <h1>Настройки</h1>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <div class="content_block">
            <div class="container">
                <div>
                    <div class="row">
                        <div class="col-lg-2">
                        <h4>Токен авторизации:</h4>
                        </div>
                        <div class="col">
                        <base-input v-model="settings.token" disabled></base-input>
                        </div>
                        <div class="col-lg-2">
                        <base-button type="warning" v-on:click="RevokeToken">Сбросить</base-button>
                        </div>
                    </div>
                </div>
             </div> <!-- container -->
          </div> <!-- content_block -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data() {
    return {
      settings: {
          "token": null
      }
    }
  },
  methods: {
    async Settings() {
      const response = await axios.get('dashboard/settings')
      this.settings.token = response.data.token
    },
    async RevokeToken() {
      if(confirm("Вы уверены что хотите сбросить токен?")){
        const response = await axios.post('dashboard/settings/revoke')
        if(response.data.status == true) {
          this.$notify({
            title: 'Успешно',
            message: 'Токен авторизации сброшен.',
            type: 'success'
          });
        }
        this.settings.token = response.data.token
      }
    },
  },
  mounted() {
    this.Settings();
  },
  created () {
  },
};
</script>

<style scoped lang="scss">
.myform2 {
  max-width: 150px;
}
.mypb {
  padding-bottom: 63px;
}
h1 {
  color: #fff;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 0;
}
h3 {
  font-size: 22px;
  padding-bottom: 0.5rem;
  font-weight: 600;
}
.limit {
  &_text {
    font-size: 15px;
    margin-top: 10px;
  }
  &_switch {
    margin-top: 11px;
  }
}
.content_block {
  display: block;
  padding: 25px 20px;
  border-radius: 0.375rem;
  position: relative;
  background: #fff;
}
.bg-gradient {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important
}
.add_btn {
  border: none;
  text-align: center;
  background: rgba(1, 204, 1, 0.288);
  color: rgba(3, 173, 3, 0.904);
  font-size: 17px;
  width: 330px;
  border-radius: 7px;
  margin-bottom: 8px;
  height: 45px;
  font-weight: 500;
  outline: none!important;
  transition: all 0.2s;
}
.add_btn:hover {
  cursor: pointer;
  background: rgba(1, 204, 1, 0.432);
}
.add_btn:active {
  background: rgba(1, 204, 1, 0.432);
}
.add_btn:focus {
  background: rgba(1, 204, 1, 0.432);
}
</style>
